const GoogleAuth = function () {
  function Auth() {
    if (!(this instanceof Auth)) return new Auth();
    this.getAuthCode = (successCallback, errorCallback, extraScopes) => {
      const scope = extraScopes || 'profile email';
      try {
        window.google.accounts.oauth2
          .initCodeClient({
            client_id:
              '527647386618-qvf4ek26753nqqb25rlo1rtlj71v56fa.apps.googleusercontent.com',
            scope,
            ux_mode: 'popup',
            callback: successCallback,
            include_granted_scopes: true,
            select_account: true,
          })
          .requestCode();
      } catch (e) {
        if (typeof errorCallback === 'function') errorCallback(e);
      }
    };
  }

  return new Auth();
};

export default GoogleAuth;
